/** Shared helpers for the AutoLISP standard library subrs. */

import { LispError } from '../errors';
import {
    numVal,
    strVal,
    type LispRuntimeApi,
    type LispValue,
    type SubrFn,
} from '../values';

/** Define one built-in function on the runtime's global environment. */
export function define(rt: LispRuntimeApi, name: string, fn: SubrFn): void {
    rt.globalEnv.define(name, { k: 'subr', name, fn });
}

export function expectNumber(v: LispValue, fn: string): number {
    if (v.k !== 'int' && v.k !== 'real') throw new LispError(`${fn}: bad argument type`);
    return numVal(v);
}

export function expectInt(v: LispValue, fn: string): number {
    if (v.k !== 'int' && v.k !== 'real') throw new LispError(`${fn}: bad argument type`);
    return Math.trunc(numVal(v));
}

export function expectString(v: LispValue, fn: string): string {
    if (v.k !== 'str') throw new LispError(`${fn}: bad argument type`);
    return strVal(v);
}

export function expectList(v: LispValue, fn: string): Extract<LispValue, { k: 'list' }> {
    if (v.k !== 'list') throw new LispError(`${fn}: bad argument type`);
    return v;
}

export function expectIntValueOnly(v: LispValue, fn: string): number {
    if (v.k !== 'int') throw new LispError(`${fn}: bad argument type`);
    return v.v;
}
